import React, { useState, useEffect } from 'react';

const ImageWithFallback = ({
    src,
    alt,
    className,
    style,
    fallbackSrc = null,
    ...props
}) => {
    const [imgSrc, setImgSrc] = useState(src);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    // Generate a consistent placeholder based on the alt text
    const getPlaceholder = () => {
        const colors = [
            '#2563eb', '#7c3aed', '#db2777', '#ea580c', '#16a34a', '#0284c7',
            '#9333ea', '#c2410c', '#b45309', '#1e40af', '#0f766e', '#b91c1c'
        ];
        const index = alt.length % colors.length;
        const bgColor = colors[index];

        // Create an SVG placeholder with the product name initials
        const words = alt.split(' ').filter(word => word.length > 0);
        let initials = '';

        if (words.length >= 2) {
            // Take first letter of first two words
            initials = words[0][0] + words[1][0];
        } else if (words.length === 1) {
            // Take first two letters of the single word
            initials = words[0].substring(0, 2);
        } else {
            initials = '??';
        }

        initials = initials.toUpperCase();

        return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='${bgColor.replace('#', '%23')}'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial, sans-serif' font-size='48' fill='%23ffffff' font-weight='bold'%3E${initials}%3C/text%3E%3C/svg%3E`;
    };

    const handleError = () => {
        if (!error) {
            setError(true);
            setLoading(false);
            if (fallbackSrc) {
                setImgSrc(fallbackSrc);
            } else {
                setImgSrc(getPlaceholder());
            }
        }
    };

    const handleLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        // Reset state when src changes
        setImgSrc(src);
        setError(false);
        setLoading(true);
    }, [src]);

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
            {loading && !error && (
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'var(--gray-100)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    animation: 'pulse 1.5s ease-in-out infinite'
                }}>
                    <div style={{
                        width: '30px',
                        height: '30px',
                        border: '3px solid var(--gray-300)',
                        borderTopColor: 'var(--blue-600)',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }} />
                </div>
            )}
            <img
                src={imgSrc}
                alt={alt}
                className={className}
                style={{
                    ...style,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    opacity: loading ? 0 : 1,
                    transition: 'opacity 0.3s ease',
                    background: error ? 'var(--gray-100)' : 'none',
                }}
                onError={handleError}
                onLoad={handleLoad}
                loading="lazy"
                {...props}
            />
        </div>
    );
};

export default ImageWithFallback;